import { render, staticRenderFns } from "./PhysicianForm.vue?vue&type=template&id=6655e1ea&"
import script from "./PhysicianForm.vue?vue&type=script&lang=ts&"
export * from "./PhysicianForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports